/**
 * Contact Button - Listing action for contacting agents
 *
 * Brand filled button for contact actions and sending messages.
 * This is typically the primary action button. Can be used in
 * footers, cards, CTAs, or any context where contact functionality
 * is needed.
 */

import { Button } from '../../../ui/Button';

/**
 * Props for listing action buttons
 */
export type ListingActionButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

/**
 * Contact Button Component
 *
 * @example
 * <ContactButton
 *   onClick={() => contactAgent(listing)}
 * />
 */
export const ContactButton = ({ onClick, disabled = false }: ListingActionButtonProps) => (
  <Button shape="rectangle" tone="brand" emphasis="filled" fluid={true} onClick={onClick} disabled={disabled}>
    Contact
  </Button>
);
